module.exports = __webpack_public_path__ + "static/media/УОМШ-2024-1.40faab05.pdf";